'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var defaultStyle = exports.defaultStyle = {
  '.loadingWrapper': {
    fontFamily: 'Helvetica'
  },
  '& .fade-out-exit': {
    opacity: '1'
  },
  '& .fade-out-exit.fade-out-exit-active': {
    opacity: '0.01',
    transition: 'opacity 1000ms ease-in-out'
  },
  '& .inner': {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'fixed',
    background: 'white',
    left: '0',
    top: '0',
    width: '100vw',
    height: '100vh',
    opacity: '.85',
    boxShadow: '5px 5px 5px lightgray',
    textAlign: 'center',
    margin: '0 auto',
    zIndex: '500'
  },
  '& .loading': {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    marginTop: '-8.5em'
  },
  '& .spinner': {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nike/ruxac/components/LoadingScreen/LoadingScreen.style.js
// module id = 481
// module chunks = 0